<template>
<div>
    <div class="mt-2">
        <v-btn text @click="$router.push(goTo)">
            <v-icon size="14px" color="grey darken-3" class="mr-3">fa-angle-left</v-icon>
            Back to teams
        </v-btn>
    </div>

    <v-row v-if="loaded">
        <v-col cols="12" sm="7">
            <v-card flat outlined>
                <v-card-text>
                    <div class="title accent--text">Create new team</div>

                    <div class="d-flex align-center mt-3" v-if="user.role.master">
                        <v-icon small class="mr-3">fa-store-alt</v-icon>
                        <v-select
                            v-model="model.center"
                            :items="centers"
                            item-text="name"
                            item-value="id"
                            append-icon="fa-angle-down primary--text"
                            @change="getGroups"
                            label="Select center">
                        </v-select>
                    </div>

                    <div class="d-flex align-center mt-3" v-if="user.role.director">
                        <v-icon small class="mr-3">fa-store-alt</v-icon>
                        <div class="subtitle-1">{{centerName}} Center</div>
                    </div>

                    <div class="d-flex align-center mt-3">
                        <v-icon small class="mr-3">fa-calendar</v-icon>
                        <v-select
                            v-model="model.group"
                            :items="groups"
                            item-text="str"
                            item-value="id"
                            append-icon="fa-angle-down primary--text"
                            label="Select group"
                            :disabled="model.center=='' || groups.length==0">
                        </v-select>
                    </div>

                    <div class="mt-n4 ml-6 error--text" v-if="groups.length==0 && model.center!=''">
                        <v-icon size="14px" class="mr-1" color="error">fa-exclamation-triangle</v-icon>
                        There is no groups for the selected center.
                    </div>

                    <div class="d-flex align-end mt-4">
                        <v-icon small class="mr-3 mb-1">fa-tag</v-icon>
                        <v-text-field
                            v-model="model.name"
                            label="Name of the team"
                            maxlength="40"
                            @keydown.enter="validate"
                            hide-details>
                        </v-text-field>
                    </div>

                    <div class="text-end mt-10">
                        <v-btn 
                            depressed 
                            class="accent" 
                            @click="validate" 
                            :disabled="sending">Add team</v-btn>
                    </div>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>

    <SendingLoader v-else/>
</div>
</template>

<script>
import _ from 'lodash'
import Helpers from '@/services/helpers'
import Teams from '@/firebase/teams'
import Groups from '@/firebase/groups'
import Centers from '@/firebase/centers'

export default {
    data: () => ({
        loaded: false,
        sending: false,
        model: {
            name: '',
            center: '',
            group: ''
        },
        centerName: '',
        centers: [],
        groups: []
    }),
    mounted() {
        this.init();
    },
    methods: {
        init() {
            Centers.getAll()
                    .then(response => {
                        if (response.status === true) {
                            this.centers = Helpers.formatItems(response.query);
                            if (this.user.role.director) {
                                this.centerName = this.getCenter(this.user.center).name;
                            }

                            this.getGroups();
                        } else {
                            this.$store.dispatch('setSnack', {kind:'error', text:'An error ocurred. Please try later.'});
                        }
                    });
        },
        getGroups() {
            this.groups = [];

            Groups.getByCenter(this.model.center)
                    .then(response => {
                        if (response.status === true) {
                            this.groups = Helpers.formatItems(response.query);
                            this.formatSchedules();
                            this.loaded = true;
                        } else {
                            this.$store.dispatch('setSnack', {kind:'error', text:'An error ocurred. Please try later.'});
                        }
                    });
        },
        formatSchedules(gr) {
            this.groups.forEach(dt => {
                dt.str = dt.day + ' / ' + dt.hour;
            });
        },
        getCenter(id) {
            let tempo;
            this.centers.forEach(dt => {
                if (dt.id == id) {
                    tempo = dt;
                }
            });

            this.model.center = id;

            return tempo;
        },
        validate() {
    		if (this.validateIsEmpty(this.model.center)) {
    			window.scrollTo(0, 0);
                this.$store.dispatch('setSnack', {kind:'error', text:'You have to select a center.'});
                return;
            }

            if (this.validateIsEmpty(this.model.group)) {
    			window.scrollTo(0, 0);
                this.$store.dispatch('setSnack', {kind:'error', text:'You have to select a group.'});
                return;
            }

            if (this.validateIsEmpty(this.model.name)) {
    			window.scrollTo(0, 0);
                this.$store.dispatch('setSnack', {kind:'error', text:'You have to set a name.'});
                return;
            }

            this.add();
    	},
        add() {
            this.sending = true;

            let c = _.find(this.centers, center => {return center.id == this.model.center})
            this.model.center = {
                id: c.id,
                name: c.name
            }

            let g = _.find(this.groups, group => {return group.id == this.model.group})
            this.model.group = {
                id: g.id,
                day: g.day,
                hour: g.hour,
                reference: g.reference
            }

            this.model.photo = null;

            Teams.add(this.model)
                    .then(response => {
                        if (response === true) {
                            this.$router.push('/admin-teams');
                            this.$store.dispatch('setSnack', {kind:'success', text:'A team has added.'});
                        } else {
                            this.$store.dispatch('setSnack', {kind:'error', text:'An error ocurred. Please try later.'});
                        }
                    });
        }
    }
}
</script>